/*
 *
 * MainLayout constants
 *
 */
export const FLUSH_STATE = 'app/MainLayout/FLUSH_STATE';
